import { render, staticRenderFns } from "./ordersFDExternal.vue?vue&type=template&id=3bddff0e"
import script from "./ordersFDExternal.vue?vue&type=script&lang=js"
export * from "./ordersFDExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports